// You can write more code here

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from '@/game/scenes/TilemapScenes/TilemapScene';

/* START OF COMPILED CODE */

export default class Level26 extends TilemapScene {
  constructor() {
    super('Level26');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_10
    const forest_biome_10 = this.add.tilemap('forest-biome-10');
    forest_biome_10.addTilesetImage(
      'summer forest wang tiles',
      'summer forest wang tiles',
    );
    forest_biome_10.addTilesetImage(
      'summer water sparkles B',
      'summer water sparkles B 16x16',
    );
    forest_biome_10.addTilesetImage('summer forest', 'summer forest');
    forest_biome_10.addTilesetImage('collision', 'collision & alpha');
    forest_biome_10.addTilesetImage(
      'summer trees 80x112',
      'summer trees 80x112',
    );
    forest_biome_10.addTilesetImage('summer 16x32', 'summer 16x32');
    forest_biome_10.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_10.addTilesetImage('summer 48x32', 'summer 48x32');

    // tilemapLayers
    const tilemapLayers = this.add.container(0, 0);

    // wang_Terrain_1
    const wang_Terrain_1 = forest_biome_10.createLayer(
      'Wang Terrain',
      ['summer forest wang tiles'],
      0,
      0,
    )!;
    tilemapLayers.add(wang_Terrain_1);

    // water_Sparkles_1
    const water_Sparkles_1 = forest_biome_10.createLayer(
      'Water Sparkles',
      ['summer water sparkles B'],
      0,
      0,
    )!;
    tilemapLayers.add(water_Sparkles_1);

    // river_Details___summer_forest_1
    const river_Details___summer_forest_1 = forest_biome_10.createLayer(
      'River Details - summer forest',
      ['summer forest'],
      0,
      0,
    )!;
    tilemapLayers.add(river_Details___summer_forest_1);

    // player
    const player = new Player(this, 336, 52);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 76, 480);
    this.add.existing(portal);

    // nPC
    const nPC = new WorldNode(this, 164, 76);
    this.add.existing(nPC);

    // nPC_1
    const nPC_1 = new WorldNode(this, 404, 120);
    this.add.existing(nPC_1);

    // nPC_2
    const nPC_2 = new WorldNode(this, 596, 140);
    this.add.existing(nPC_2);

    // nPC_3
    const nPC_3 = new WorldNode(this, 608, 368);
    this.add.existing(nPC_3);

    // nPC_4
    const nPC_4 = new WorldNode(this, 76, 392);
    this.add.existing(nPC_4);

    // nPC_5
    const nPC_5 = new WorldNode(this, 356, 492);
    this.add.existing(nPC_5);

    // nPC_6
    const nPC_6 = new WorldNode(this, 184, 508);
    this.add.existing(nPC_6);

    // nPC_7
    const nPC_7 = new WorldNode(this, 448, 364);
    this.add.existing(nPC_7);

    // nPC_8
    const nPC_8 = new WorldNode(this, 616, 264);
    this.add.existing(nPC_8);

    // nPC_9
    const nPC_9 = new WorldNode(this, 516, 88);
    this.add.existing(nPC_9);

    // mentor1
    const mentor1 = new Mentor1(this, 256, 96);
    this.add.existing(mentor1);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 384, 340);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 420, 260);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 356, 200);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(this, 312, 276);
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 248, 228);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      432,
      344,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      348,
      316,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      400,
      244,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      292,
      216,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      224,
      220,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      328,
      264,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      268,
      256,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      316,
      300,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      376,
      272,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      456,
      296,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      328,
      204,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      208,
      200,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      680,
      148,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      524,
      44,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      460,
      20,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      596,
      32,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      648,
      96,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      712,
      224,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      712,
      168,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      660,
      128,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      564,
      60,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      500,
      36,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      704,
      44,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 712, 88);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 652, 52);
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(this, 604, 80);
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(this, 548, 68);
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(this, 624, 12);
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(this, 20, 600);
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(this, -4, 500);
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(this, 148, 600);
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(this, 624, 576);
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(this, 728, 520);
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(this, 672, 460);
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(
      this,
      -12,
      452,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(
      this,
      84,
      620,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(
      this,
      672,
      584,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(
      this,
      556,
      532,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(
      this,
      716,
      464,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_42);

    // forestTree_43
    const forestTree_43 = new ForestTree1(
      this,
      4,
      576,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_43);

    // forestTree_44
    const forestTree_44 = new ForestTree1(
      this,
      128,
      596,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_44);

    // forestTree_45
    const forestTree_45 = new ForestTree1(
      this,
      580,
      584,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(
      this,
      692,
      512,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_46);

    // forestTree_47
    const forestTree_47 = new ForestTree1(
      this,
      716,
      588,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_47);

    // forestTree_48
    const forestTree_48 = new ForestTree1(
      this,
      672,
      416,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_48);

    // nPC (prefab fields)
    nPC.NPCLevelId = 25;
    nPC.NPCId = 0;

    // nPC_1 (prefab fields)
    nPC_1.NPCLevelId = 25;
    nPC_1.NPCId = 1;

    // nPC_2 (prefab fields)
    nPC_2.NPCLevelId = 25;
    nPC_2.NPCId = 2;

    // nPC_3 (prefab fields)
    nPC_3.NPCLevelId = 25;
    nPC_3.NPCId = 3;

    // nPC_4 (prefab fields)
    nPC_4.NPCLevelId = 25;
    nPC_4.NPCId = 4;

    // nPC_5 (prefab fields)
    nPC_5.NPCLevelId = 25;
    nPC_5.NPCId = 5;

    // nPC_6 (prefab fields)
    nPC_6.NPCLevelId = 25;
    nPC_6.NPCId = 6;

    // nPC_7 (prefab fields)
    nPC_7.NPCLevelId = 25;
    nPC_7.NPCId = 7;

    // nPC_8 (prefab fields)
    nPC_8.NPCLevelId = 25;
    nPC_8.NPCId = 8;

    // nPC_9 (prefab fields)
    nPC_9.NPCLevelId = 25;
    nPC_9.NPCId = 9;

    this.player = player;
    this.portal = portal;
    this.nPC = nPC;
    this.nPC_1 = nPC_1;
    this.nPC_2 = nPC_2;
    this.nPC_3 = nPC_3;
    this.nPC_4 = nPC_4;
    this.nPC_5 = nPC_5;
    this.nPC_6 = nPC_6;
    this.nPC_7 = nPC_7;
    this.nPC_8 = nPC_8;
    this.nPC_9 = nPC_9;
    this.mentor1 = mentor1;
    this.forest_biome_10 = forest_biome_10;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private nPC!: WorldNode;
  private nPC_1!: WorldNode;
  private nPC_2!: WorldNode;
  private nPC_3!: WorldNode;
  private nPC_4!: WorldNode;
  private nPC_5!: WorldNode;
  private nPC_6!: WorldNode;
  private nPC_7!: WorldNode;
  private nPC_8!: WorldNode;
  private nPC_9!: WorldNode;
  private mentor1!: Mentor1;
  private forest_biome_10!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_10,
      portal: this.portal,
      mentor: this.mentor1,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
